import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import {
  ArrowRight,
  Music,
  Globe,
  DollarSign,
  BarChart4,
  Headphones,
  Award,
  Users,
  Copyright,
  Youtube,
  FileText,
  LineChart,
  Code,
  Timer,
  Clock,
  Link2,
  BoomBox,
  SquarePlay,
  Instagram,
  Tv,
  Tv2,
  Building2,
  UserRoundCog,
  BotMessageSquare,
  ListVideo,
  ChartColumnIncreasing
} from "lucide-react";
import useScrollToTop from "@/hooks/useScrollToTop";
import { Link } from "react-router-dom";
import StreamingPlatforms from "@/pages/home/StreamingPlatforms";
import { Helmet } from "react-helmet-async";
import { DASHBOARD_SIGNUP_URL } from "@/config/urls";

const Services = () => {
  useScrollToTop();

  // const servicesList = [
  //   {
  //     number: "01",
  //     title: "Music Distribution",
  //     description: "Get your music on all major streaming platforms including Spotify, Apple Music, Amazon Music, and more."
  //   },
  //   {
  //     number: "02",
  //     title: "Global Reach",
  //     description: "Distribute your music to over 150+ streaming platforms worldwide, reaching listeners in every corner of the globe."
  //   },
  //   {
  //     number: "03",
  //     title: "100% ownership",
  //     description: "Keep 100% of your streaming ownership with our artist-friendly subscription model. No hidden fees or revenue sharing."
  //   },
  //   {
  //     number: "04",
  //     title: "Advanced Analytics",
  //     description: "Track your performance across all platforms with detailed insights and audience demographics to grow your fanbase."
  //   },
  //   {
  //     number: "05",
  //     title: "Playlist Promotion",
  //     description: "Get your music featured on popular playlists to increase your reach and grow your audience organically."
  //   },
  //   {
  //     number: "06",
  //     title: "Music Licensing",
  //     description: "License your music for TV, film, commercials, and more to unlock additional revenue streams for your work."
  //   }
  // ];

  const mainServices = [
    {
      icon: <Music className="text-ophira-yellow" size={48} />,
      title: "Music Distribution",
      description: "Get your music on all major streaming platforms"
    },
    {
      icon: <Globe className="text-ophira-yellow" size={48} />,
      title: "Global Reach",
      description: "Distribute to over 150+ platforms worldwide"
    },
    {
      icon: <DollarSign className="text-ophira-yellow" size={48} />,
      title: "100% Ownership",
      description: "Keep all your music ownership and royalties with our subscription model"
    },
    {
      icon: <BarChart4 className="text-ophira-yellow" size={48} />,
      title: "Advanced Analytics",
      description: "Track performance with detailed insights"
    },
    {
      icon: <Headphones className="text-ophira-yellow" size={48} />,
      title: "Playlist Promotion",
      description: "Get featured on popular playlists"
    },
    {
      icon: <Copyright className="text-ophira-yellow" size={48} />,
      title: "Music Licensing",
      description: "License your music for various media"
    }
  ];

  const additionalServices = [
    {
      icon: <Youtube className="text-ophira-yellow" size={36} />,
      title: "Free Official Artist Channel",
      description: "Get your own official artist channel on YouTube."
    },
    {
      icon: <Clock className="text-ophira-yellow" size={36} />,
      title: "24 Hour Release",
      description: "Get your music released within 24 hours across all major platforms."
    },
    {
      icon: <Users className="text-ophira-yellow" size={36} />,
      title: "CMS Service (Selected Users)",
      description: "Access to YouTube CMS for eligible users."
    },
    {
      icon: <DollarSign className="text-ophira-yellow" size={36} />,
      title: "Access to Funding",
      description: "Apply for funding under YouAux Select."
    },
    {
      icon: <BoomBox className="text-ophira-yellow" size={36} />,
      title: "Record Label Platform",
      description: "Launch your own music label on YouTube."
    },
    {
      icon: <ChartColumnIncreasing className="text-ophira-yellow" size={36} />,
      title: "Analytics Dashboard",
      description: "Get access to analytics dashboard for youtube, spotify, apple music, and more."
    },
    {
      icon: <BotMessageSquare className="text-ophira-yellow" size={36} />,
      title: "AI Tools Features",
      description: "Get access to AI tools features."
    },
    {
      icon: <ListVideo className="text-ophira-yellow" size={36} />,
      title: "Artist & Playlist Promotion",
      description: "Get artist and playlist promotion, including playlist pitching."
    },
    {
      icon: <Globe className="text-ophira-yellow" size={36} />,
      title: "Bulk Distribution",
      description: "Distribute your music in bulk to all platforms."
    },
    {
      icon: <LineChart className="text-ophira-yellow" size={36} />,
      title: "WARM Radio Tracking",
      description: "Track your music on radio worldwide with WARM."
    },
    {
      icon: <Tv2 className="text-ophira-yellow" size={36} />,
      title: "Vevo Distribution",
      description: "Distribute your music to Vevo."
    },
    {
      icon: <Copyright className="text-ophira-yellow" size={36} />,
      title: "Neighbouring Rights Collection",
      description: "Collect neighbouring rights royalties globally."
    },
    {
      icon: <UserRoundCog className="text-ophira-yellow" size={36} />,
      title: "Custom Marketing Campaign Support",
      description: "Get support for custom marketing campaigns."
    },
    {
      icon: <Building2 className="text-ophira-yellow" size={36} />,
      title: "Premium Industry Connections",
      description: "Connect with premium industry professionals."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Services | YouAux</title>
        <meta
          name="description"
          content="Comprehensive solutions to help independent artists succeed in today's music industry. Our platform offers everything you need to create, distribute, and monetize your music globally."
        />
        <link rel="canonical" href="https://youaux.com/services" />
      </Helmet>
      <div className="bg-black min-h-screen">
        <Navbar />
        <main className="pt-32 pb-20">
          <section className="container mx-auto px-4">
            <div className="max-w-4xl">
              <div className="ophira-section-label">OUR SERVICES</div>
              <h1 className="ophira-section-title mb-8">Our Music Services</h1>
              <p className="text-ophira-lightgray max-w-2xl mb-12">
                Comprehensive solutions to help independent artists succeed in today's music industry. Our platform offers
                everything you need to create, distribute, and monetize your music globally.
              </p>
            </div>

            <StreamingPlatforms />

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-20">
              {mainServices.map((item, index) => (
                <div
                  key={index}
                  className="bg-ophira-darkgray/30 p-8 group hover:bg-ophira-darkgray/50 transition-all duration-300 rounded-xl border border-white/10"
                >
                  <div className="mb-6">{item.icon}</div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-ophira-yellow transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-ophira-lightgray">{item.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-24 mb-8">
              <div className="ophira-section-label">ADDITIONAL SERVICES</div>
              <h3 className="text-3xl font-bold text-white mb-12">More Tools For Your Success</h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-16">
              {additionalServices.map((service, index) => (
                <div
                  key={index}
                  className="bg-ophira-darkgray/30 p-8 group hover:bg-ophira-darkgray/50 transition-all duration-300 relative rounded-xl border border-white/10"
                >
                  <div className="mb-6">{service.icon}</div>
                  <h3 className="text-xl font-bold text-white mb-4">{service.title}</h3>
                  <p className="text-ophira-lightgray text-sm">{service.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-20 flex justify-center">
              <a href={DASHBOARD_SIGNUP_URL}>
                <Button className="ophira-button text-lg py-6 px-10">Begin Your Journey Today</Button>
              </a>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Services;
